import { StrictMode, lazy } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router";
import "./i18n";
import MainLayout from "@/layouts/mainLayout.tsx";
import { AuthProvider } from "@/contexts/auth-context.provider";
import DetailedSubscriptionScreen from "@/screens/detailedSubscriptionScreen/detailedSubscriptionScreen";

const MainScreen = lazy(() => import("@/screens/mainScreen/mainScreen"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<MainScreen />} />
            <Route path="/subscriptions/:subscriptionId" element={<DetailedSubscriptionScreen />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
